function initializeAudience() {
    document.querySelectorAll('[data-campaign-audience]').forEach(root => {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        const mode = root.querySelector('#recipient_mode');
        const individual = root.querySelector('#individual-fields');
        const filters = root.querySelector('#filter-fields');
        const manual = root.querySelector('#manual-fields');
        const form = root.closest('form');
        const submit = form.querySelector('[data-campaign-submit]');
        const extra = root.querySelector('[data-extra-filters]');
        const status = root.querySelector('[data-audience-status]');
        const retry = root.querySelector('[data-count-retry]');
        const counter = root.querySelector('[data-audience-counter]');
        const search = root.querySelector('#member-search');
        const results = root.querySelector('#member-results');
        const selected = root.querySelector('#selected-members');
        const csrf = root.closest('form').querySelector('[name="_token"]').value;
        const format = new Intl.NumberFormat('es-AR');
        let timer, controller, version = 0, searchTimer, searchController, searchVersion = 0;

        const updateLabels = () => {
            root.querySelectorAll('[data-audience-options]').forEach(list => {
                const n = list.querySelectorAll('input:checked').length;
                list.querySelector('[data-options-summary]').textContent = n ? `${n} seleccionada${n === 1 ? '' : 's'}. Podés marcar varias.` : 'Sin selección: todas. Podés marcar varias.';
            });
            const n = [...extra.querySelectorAll('[name]')].filter(el => el.value !== '' && el.value !== 'all').length;
            root.querySelector('[data-extra-count]').textContent = n ? `(${n} aplicado${n === 1 ? '' : 's'})` : '(opcional)';
            return n;
        };
        const toggleMode = () => {
            individual.classList.toggle('hidden', mode.value !== 'individual');
            filters.classList.toggle('hidden', mode.value !== 'filters');
            manual.classList.toggle('hidden', mode.value !== 'manual');
            counter.hidden = mode.value === 'manual';
            manual.querySelectorAll('input').forEach(input => {
                input.disabled = mode.value !== 'manual';
                if (input.type !== 'hidden') input.required = mode.value === 'manual';
            });
            form.querySelector('[data-campaign-name]').classList.toggle('hidden', mode.value === 'manual');
            form.querySelector('[name="name"]').required = mode.value !== 'manual';
            form.querySelector('[data-campaign-submit-label]').textContent = mode.value === 'manual' ? 'Enviar correo' : 'Guardar y revisar destinatarios';
        };
        const payload = () => {
            const body = new FormData();
            body.append('recipient_mode', mode.value);
            const panel = mode.value === 'individual' ? individual : filters;
            panel.querySelectorAll('[name]').forEach(el => {
                if (el.type !== 'checkbox' || el.checked) body.append(el.name, el.value);
            });
            return body;
        };
        const calculate = async current => {
            controller = new AbortController();
            try {
                const response = await fetch(root.dataset.countUrl, {method:'POST', credentials:'same-origin', signal:controller.signal, headers:{Accept:'application/json','X-CSRF-TOKEN':csrf}, body:payload()});
                const data = await response.json().catch(() => ({}));
                if (current !== version) return;
                if (!response.ok) throw new Error(response.status === 422 ? (Object.values(data.errors || {}).flat().join(' ') || 'Revisá los filtros ingresados.') : 'No se pudo calcular la audiencia. Reintentá en unos segundos.');
                for (const key of ['total', 'eligible', 'invalid', 'blocked']) root.querySelector(`[data-count="${key}"]`).textContent = format.format(data[key]);
                status.textContent = data.total === 0 ? 'Ningún socio coincide con la selección actual.' : `${format.format(data.eligible)} ${data.eligible === 1 ? 'socio podrá' : 'socios podrán'} recibir este correo; los emails inválidos o bloqueados se excluyen.`;
            } catch (error) {
                if (error.name === 'AbortError' || current !== version) return;
                status.textContent = error.message; retry.hidden = false;
            } finally {
                if (current === version) counter.removeAttribute('aria-busy');
            }
        };
        const schedule = (delay = 350) => {
            clearTimeout(timer); controller?.abort();
            const current = ++version;
            updateLabels(); toggleMode();
            if (mode.value === 'manual') {
                counter.removeAttribute('aria-busy');
                return;
            }
            retry.hidden = true; counter.setAttribute('aria-busy', 'true');
            root.querySelectorAll('[data-count]').forEach(el => { el.textContent = '—'; });
            status.textContent = 'Calculando destinatarios…';
            timer = setTimeout(() => calculate(current), delay);
        };
        root.addEventListener('input', event => { if (event.target.name) schedule(); });
        root.addEventListener('change', event => { if (event.target.name) schedule(); });
        retry.addEventListener('click', () => schedule(0));
        root.querySelectorAll('[data-clear-options]').forEach(button => button.addEventListener('click', () => {
            button.closest('[data-audience-options]').querySelectorAll('input').forEach(el => { el.checked = false; }); schedule();
        }));
        root.querySelector('[data-clear-filters]').addEventListener('click', () => {
            filters.querySelectorAll('[name]').forEach(el => {
                if (el.type === 'checkbox') el.checked = false;
                else el.value = el.name === 'status_filter' ? 'active' : el.tagName === 'SELECT' && el.name !== 'province_id' ? 'all' : '';
            });
            extra.open = false; schedule();
        });
        selected.addEventListener('click', event => {
            const button = event.target.closest('[data-remove-member]');
            if (button) { button.closest('[data-id]').remove(); schedule(); }
        });
        search.addEventListener('input', () => {
            clearTimeout(searchTimer); searchController?.abort();
            const current = ++searchVersion, q = search.value.trim();
            results.replaceChildren(); results.classList.toggle('hidden', q.length < 2);
            if (q.length < 2) return;
            results.textContent = 'Buscando…';
            searchTimer = setTimeout(async () => {
                searchController = new AbortController();
                try {
                    const response = await fetch(`${root.dataset.membersUrl}?q=${encodeURIComponent(q)}`, {signal:searchController.signal, headers:{Accept:'application/json'}});
                    if (!response.ok) throw new Error('No se pudo buscar socios. Volvé a intentar.');
                    const members = await response.json();
                    if (current !== searchVersion) return;
                    results.replaceChildren();
                    for (const member of members) {
                        const button = document.createElement('button');
                        button.type = 'button'; button.className = 'block w-full px-3 py-2 text-left text-sm hover:bg-zinc-100 dark:hover:bg-white/10';
                        button.textContent = `${member.label} · ${member.email || 'sin email'}`;
                        button.addEventListener('click', () => {
                            if (!selected.querySelector(`[data-id="${Number(member.id)}"]`)) {
                                const tag = document.createElement('span'); tag.dataset.id = member.id;
                                tag.className = 'inline-flex max-w-full items-center gap-2 rounded-lg bg-zinc-100 px-3 py-2 text-sm dark:bg-white/10';
                                const label = document.createElement('span'); label.className = 'min-w-0 break-words'; label.textContent = member.label;
                                const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.removeMember = member.id; remove.textContent = '×'; remove.setAttribute('aria-label', `Quitar a ${member.label}`);
                                const input = document.createElement('input'); input.type = 'hidden'; input.name = 'member_ids[]'; input.value = member.id;
                                tag.append(label, remove, input); selected.append(tag);
                            }
                            search.value = ''; results.classList.add('hidden'); schedule();
                        });
                        results.append(button);
                    }
                    if (!members.length) results.textContent = 'Sin resultados.';
                } catch (error) {
                    if (error.name !== 'AbortError' && current === searchVersion) results.textContent = error.message;
                }
            }, 250);
        });
        extra.open = updateLabels() > 0;
        form.addEventListener('submit', event => {
            if (!event.defaultPrevented && mode.value === 'manual') {
                submit.disabled = true;
                form.querySelector('[data-campaign-submit-label]').textContent = 'Preparando envío…';
            }
        });
        schedule(0);
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAudience);
else initializeAudience();
document.addEventListener('livewire:navigated', initializeAudience);
